export default __webpack_public_path__ + "static/media/question_3_a.fc393e7e.jpg";